import React ,{useState, useEffect} from 'react'
import {Link, useNavigate} from "react-router-dom"

const Signup = (props) => {
  let navigate = useNavigate();
  useEffect(() => {
    props.showLoading()
    if(localStorage.getItem("auth-token")!==null){
      navigate('/')
    }
    setTimeout(()=>{
      props.completeLoading()
    },100)
    //eslint-disable-next-line
  }, [])

  document.title = props.title;
    const [signupDetails, setSignupDetials] = useState({name:"" ,email: "", password: ""})
    const onChange = (e)=>{
        setSignupDetials({...signupDetails, [e.target.name] : e.target.value})
    }
    const handleSubmit = async (e) => {
      props.showLoading();
      e.preventDefault();
      const host = "https://noteboss-backend.onrender.com";
      const url = `${host}/api/auth/createuser`;
        const response = await fetch(url, {
          headers: {
            "content-type":
              "application/json"
          },
          method: "POST",
          body: JSON.stringify({ name: signupDetails.name ,email: (signupDetails.email).toLowerCase(), password: signupDetails.password }),
        });
  
        let data = await response.json();
        props.completeLoading();
        if(data.success === true){
          props.showAlert("success",data.name,"Signed Up Successfully")
          navigate("/auth/login")
        }else if(data.errorMessage === "Email Already in Use"){
            props.showAlert("warning","Warning","Email Already in Use")
        }else{
          props.showAlert("danger","Error","Some Internal Error... ")
        }
    };
    
    return (
      <div className={`container mt-2 mb-2 d-flex flex-column justify-content-center align-items-center ${props.theme === "dark" ? "text-light" : ""}`}>
        <h2>Signup | <span className="text-danger">NoteBoss</span></h2>
        <span className="fs-6 mb-3 text-secondary">Welcome to NoteBoss!</span>
        <form onSubmit={handleSubmit}>
          <div className="mb-1">
            <label htmlFor="name" className="form-label">
              Full Name
            </label>
            <input
              type="text"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              id="name"
              name="name"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={signupDetails.name}
              required
            />
          </div>
          <div className="mb-1">
            <label htmlFor="email" className="form-label">
              Email address
            </label>
            <input
              type="email"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              id="email"
              name="email"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={signupDetails.email}
              required
            />
            <div id="emailHelp" className={`form-text ${props.theme === "dark"? "text-secondary" : ""}`}>
              We'll never share your email with anyone else.
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              name="password"
              id="password"
              onChange={onChange}
              value={signupDetails.password}
              required
            />
            {signupDetails.password.length <= 3 && signupDetails.password !== ""?
            <span className='text-warning' style={{fontSize:"12px"}}> <i className="uil uil-exclamation-triangle"></i> Password must contain 4 Characters...</span>
            :""}
          </div>
          <button type="submit" className="btn btn-large btn-primary" disabled={signupDetails.password.length <= 3}>
            Signup
          </button>
        </form>
          <span className="text-center mt-3 mb-1">Existing NoteBoss User? <Link className="text-decoration-none" to="/auth/login">Login Here</Link></span>
      </div>
    );
  };

export default Signup